var map = {
	"./cn/page_download_cn.png": 2230,
	"./cn/page_email_cn.png": 6423,
	"./cn/page_facebook_cn.png": 984,
	"./cn/page_help_cn.png": 7456,
	"./cn/page_privacy_cn.png": 5694,
	"./cn/page_terms_cn.png": 2815,
	"./cn/page_weibo_cn.png": 8748,
	"./en/page_download_en.png": 6664,
	"./en/page_email_en.png": 1963,
	"./en/page_facebook_en.png": 1526,
	"./en/page_help_en.png": 838,
	"./en/page_privacy_en.png": 9769,
	"./en/page_terms_en.png": 5244,
	"./en/page_weibo_en.png": 560,
	"./tc/page_email_tc.png": 4908,
	"./tc/page_facebook_tc.png": 8251,
	"./tc/page_help_tc.png": 7372,
	"./tc/page_privacy_tc.png": 4445,
	"./tc/page_terms_tc.png": 5195,
	"./tc/page_weibo_tc.png": 8891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5718;